import router from '../../router'
import axios from 'axios'
export default {
  requestOrder ({state, commit, getters}) {
    if (state.acceptance === false) {
      commit('toastr', {
        color: 'info',
        time: 2500,
        texto: 'Aceite as condições do uso'
      })
      return
    } else if (state.itemChoosen === '') {
      commit('toastr', {
        color: 'info',
        time: 2500,
        texto: 'Escolha um item'
      })
      return
    } else if (state.timeChoosen === null) {
      commit('toastr', {
        color: 'info',
        time: 2500,
        texto: 'Escolha um horario'
      })
      return
    } else if (getters.unity !== false && state.unityChoosen === null) {
      if (getters.unity.length > 1) {
        commit('toastr', {
          color: 'info',
          time: 2500,
          texto: 'Escolha uma unidade'
        })
        return
      } else {
        commit('updateUnityChoosen', getters.unity[0])
      }
    }
    let price = state.item.priceTable.filter((elem) => {
      if (elem.provider === state.itemChoosen) {
        return elem
      }
    })
    let order
    if (price[0].priceVariations) {
      order = {
        itens: [
          {
            id: price[0].provider,
            count: 1
          }
        ],
        timeChoosen: state.timeChoosen,
        dateChoosen: state.dateChoosen,
        unit: state.unityChoosen,
        payment: state.paymentChoosen,
        item: price[0].id
      }
    } else {
      order = {
        count: 1,
        timeChoosen: state.timeChoosen,
        unit: state.unityChoosen,
        payment: state.paymentChoosen,
        item: price[0].id
      }
    }
    return new Promise((resolve, reject) => {
      commit('toggleLoadingOrderRequest', true)
      axios({
        method: 'post',
        url: process.url + 'HotSite/SaveOrder',
        timeout: 200000,
        headers: { 'Token': getters.hotSiteToken },
        data: order
      })
      .then((response) => {
        commit('toggleLoadingOrderRequest', false)
        router.push('/a/Sucesso')
        // if (response.data.resultado.success) {
        // } else {
        //   commit('toastr', {
        //     color: 'warning',
        //     texto: response.data.resultado.error
        //   })
        // }
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response)
          var description = ''
          if (erros.preErros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else if (erros.resultado) {
            description = erros.resultado
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              time: 2500,
              texto: description
            })
          }
        }
        commit('toggleLoadingOrderRequest', false)
        commit('toastrAxiosError', error)
      })
    })
  },
  getScheduleItem: async ({commit, getters}) => {
    const { data: response } = await axios.get(process.url + 'HotSite/ItensPorAgendamento', { headers: { 'Token': getters.hotSiteToken } })
    commit('loadItem', response.resultado)
    // console.log(response.resultado)
  },
  getAvaliableSchedule: async ({commit, getters}) => {
    // console.log(getters.dates[0])
    let getters2 = {
      dateChoosen: getters.dateChoosen !== '' ? getters.dateChoosen : getters.item.dates[0]
    }
    const { data: response } = await axios.get(process.url + 'HotSite/GetGradeHoras?date=' + getters2.dateChoosen, { headers: { 'Token': getters.hotSiteToken } })
    commit('loadAvaliableSchedule', response.resultado.times)
  },
  getClient: async ({commit, getters}) => {
    const { data: response } = await axios.get(process.url + 'Hotsite/GetDetalheUserByToken', { headers: { 'Token': getters.hotSiteToken } })
    commit('loadClient', response.resultado)
  },
  async choseDate ({commit, dispatch}, payload) {
    commit('toggleLoadingCheckout', true)
    commit('updateDateChoosen', payload)
    await dispatch('getAvaliableSchedule')
    commit('toggleLoadingCheckout', false)
  },
  async getAllInfo ({commit, dispatch}, token) {
    commit('toggleLoadingCheckout', true)
    commit('setHotSiteToken', token)
    try {
      await dispatch('getScheduleItem')
      await dispatch('getAvaliableSchedule')
      await dispatch('getClient')
    } catch (e) {
      commit('toastrAxiosError', e)
      commit('toggleLoadingCheckout', false)
    }
    commit('toggleLoadingCheckout', false)
  }
}



// WEBPACK FOOTER //
// ./src/store/Checkout/actions.js